import { render } from "./AgentiDataTable.vue?vue&type=template&id=5e104487&scoped=true"
import script from "./AgentiDataTable.vue?vue&type=script&lang=js"
export * from "./AgentiDataTable.vue?vue&type=script&lang=js"

import "./AgentiDataTable.vue?vue&type=style&index=0&id=5e104487&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e104487"]])

export default __exports__